import axios from "axios";
import {
    URLAPI,
    REPORT_YEARS_PATH,
    REPORT_OPTIONS_PATH,
    REPORT_PREVIEW_PATH,
    REPORT_EXPORT_PATH,
} from "../config/index";

/** @module Redux/Reports */

/**
 * Reportería de ingresos (réplica del Power BI). Las páginas guardan su propio estado, así que
 * este módulo solo expone las llamadas a la API.
 */

const headers = (token) => ({Authorization: `Token ${token}`});

/**
 * Obtiene el mensaje de error que devuelve el backend ({mensaje}) o uno genérico.
 * @param {object} error - Error de axios
 * @returns {Promise<string>}
 */
export const error_message = async (error) => {
    const data = error.response ? error.response.data : null;
    if (data instanceof Blob) {
        try {
            return JSON.parse(await data.text()).mensaje || "Ocurrió un error al generar el reporte";
        } catch (e) {
            return "Ocurrió un error al generar el reporte";
        }
    }
    return (data && data.mensaje) || error.message || "Ocurrió un error al generar el reporte";
};

/**
 * Años con visitas, para el segmentador Año.
 * @param {string} token
 * @returns {Promise<number[]>}
 */
export const get_report_years = async (token) => {
    const response = await axios.get(`${URLAPI}${REPORT_YEARS_PATH}`, {headers: headers(token)});
    return response.data;
};

/**
 * Opciones de un segmentador (nombre | centro_costo).
 * @param {string} token
 * @param {string} field
 * @returns {Promise<{value: string, label: string}[]>}
 */
export const get_report_options = async (token, field) => {
    const response = await axios.get(`${URLAPI}${REPORT_OPTIONS_PATH}${field}/`, {
        headers: headers(token),
        params: {limit: 5000},
    });
    return response.data;
};

/**
 * Datos del reporte (tabla o calendario) para los filtros indicados.
 * @param {string} token
 * @param {object} body - {type, filters, page, size}
 * @param {object} config - Opciones extra de axios (p. ej. cancelToken)
 */
export const get_report_preview = async (token, body, config = {}) => {
    const response = await axios.post(`${URLAPI}${REPORT_PREVIEW_PATH}`, body, {headers: headers(token), ...config});
    return response.data;
};

/**
 * Descarga el reporte en el formato indicado (xlsx | csv | pdf).
 * @param {string} token
 * @param {object} body - {type, filters}
 * @param {string} formato
 */
export const export_report = async (token, body, formato) => {
    const response = await axios.post(`${URLAPI}${REPORT_EXPORT_PATH}`, body, {
        headers: headers(token),
        params: {formato},
        responseType: "blob",
    });
    const disposition = response.headers["content-disposition"] || "";
    const match = /filename="?([^";]+)"?/.exec(disposition);
    const filename = match ? match[1] : `reporte.${formato}`;
    const url = URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
    return filename;
};
